<template>
  <card-with-header-and-footer-component :loading="loading">
    <template v-slot:header>
      <h3 class="text-lg font-semibold leading-5 text-gray-900 sm:line-clamp-2">{{ $t('customization.header_type') }}</h3>
    </template>

    <div>
      <label for="header-block" class="sr-only">{{ $t('customization.header_type') }}</label>
      <select id="header-block" name="header-block" v-model="themeHeaderBlock" aria-describedby="academy-header-block-description" class="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-bpblue focus:border-bpblue sm:text-sm rounded-md">
        <option value="1c01-image">{{ $t('customization.banner_complete') }}</option>
        <option value="1c02-image">{{ $t('customization.banner_complete_no_text') }}</option>
        <option value="2c01-text-image">{{ $t('customization.columns_text_image') }}</option>
      </select>
      <p class="mt-2 text-sm text-gray-500" id="academy-header-block-description">{{ $t('customization.banner_info') }}</p>
    </div>

    <template v-slot:footer>
      <button type="button" v-on:click="getHeaderBlock" :disabled="loading" class="mr-2 inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-bpblue">
        {{ $t('general.cancel') }}
      </button>

      <button type="button" v-on:click="saveHeaderBlock" :disabled="loading" class="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-bpblue hover:bg-bpbluedeep focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-bpblue">
        {{ $t('general.save') }}
      </button>
    </template>
  </card-with-header-and-footer-component>
</template>

<script>
import CardWithHeaderAndFooterComponent from "@/components/panels/CardWithHeaderAndFooterComponent";
import ColorsService from "@/services/academy/ColorsService";
import NotificationService from "@/services/notification/NotificationService";
import { useAcademiesStore } from "@/stores/academies";
import loadWhenAcademyReady from "@/mixins/loadWhenAcademyReady";

/*
 * Tipo de encabezado de la home. Se guarda en el mismo endpoint que los colores
 * (PUT /academy/colors), así que usa updateFields para no pisar los colores.
 */
export default {
  name: "HeaderBlockComponent",
  mixins: [loadWhenAcademyReady('getHeaderBlock')],
  components: {
    CardWithHeaderAndFooterComponent,
  },
  data () {
    return {
      loading: true,
      themeHeaderBlock: "",
    }
  },
  setup(){
    const academyStore = useAcademiesStore();

    return {
      academyStore
    }
  },
  methods: {
    getHeaderBlock() {
      let academy_uuid = this.academyStore.academy.uuid;
      this.loading = true;

      ColorsService.index(academy_uuid)
          .then((response) => {
            this.themeHeaderBlock = response.data.theme_header_block
          })
          .catch((response) => {
            console.log("Error obteniendo el tipo de encabezado", response)
            NotificationService.showNotification("Ha ocurrido un error inesperado", "error")
          })
          .finally(() => {
            this.loading = false
          })
    },
    saveHeaderBlock() {
      let academy_uuid = this.academyStore.academy.uuid;
      this.loading = true;

      ColorsService.updateFields(academy_uuid, {theme_header_block: this.themeHeaderBlock})
          .then((response) => {
            console.log("Se ha almacenado el tipo de encabezado correctamente", response)
            NotificationService.showNotification("El tipo de encabezado se ha almacenado correctamente", "success")

            this.academyStore.getAcademy()
          })
          .catch((error) => {
            console.log("Error almacenando el tipo de encabezado", error.response)
            if (error.response?.data?.errors)
            {
              error.response.data.errors.forEach( (error) => {
                NotificationService.showNotification(error, "error")
              })
            }
            else
            {
              NotificationService.showNotification("Ha ocurrido un error inesperado", "error")
            }
          })
          .finally(() => {
            this.loading = false
          })
    },
  },
}
</script>
